import styles from "./RelationCenterFixedTitle.scss";
import classNames from "classnames";
const cx = classNames.bind(styles);

const RelationCenterFixedTitle = ({ title }) => <h3 className={cx("history-fixed-title")}>{title}</h3>;

export default RelationCenterFixedTitle;
